module.exports = __webpack_public_path__ + "static/media/logo.b017147a.png";